<template>
  <div>
    <v-card flat>
      <v-card-text>
        <div class="flex my-4 mb-10">
          <div class="w-1/3 h-8">
            <p class="text-md-left font-weight-bold">Course Name:</p>
          </div>
          <div class="w-1/3 h-8">
            <p class="font-weight-medium">
              {{ values.courseName ? values.courseName : "-" }}
            </p>
          </div>

          <div class="w-1/3 h-8">
            <p class="text-md-left font-weight-bold">Course Code:</p>
          </div>
          <div class="w-1/3 h-8">
            <p v-if="values.courseCode" class="font-weight-medium">
              <barcode :height="50" v-bind:value="values.courseCode">
                Sorry, rendering failed!
              </barcode>
            </p>
            <p v-else class="font-weight-medium">
              {{ values.courseCode ? values.courseCode : "-" }}
            </p>
          </div>
        </div>

        <div class="flex my-4 mb-10">
          <div class="w-1/3 h-8">
            <p class="text-md-left font-weight-bold">
              Continuing Education Unit(CEU):
            </p>
          </div>
          <div class="w-1/3 h-8">
            <p class="font-weight-medium">
              {{
                values.continualEducationUnit
                    ? values.continualEducationUnit
                    : "-"
              }}
            </p>
          </div>

          <div class="w-1/3 h-8">
            <p class="text-md-left font-weight-bold">Course Level:</p>
          </div>
          <div class="w-1/3 h-8">
            <p class="font-weight-medium">
              {{ values.courseLevel ? values.courseLevel.name : "-" }}
            </p>
          </div>
        </div>
        <div class="flex my-4 mb-10">
          <div class="w-1/3 h-8">
            <p class="text-md-left font-weight-bold">Course Duration:</p>
          </div>
          <div class="w-1/3 h-8">
            <p class="font-weight-medium">
              {{ values.courseDuration ? values.courseDuration : "-" }}
            </p>
          </div>
          <div class="w-1/3 h-8">
            <p class="text-md-left font-weight-bold">Course Owner:</p>
          </div>
          <div class="w-1/3 h-8">
            <p class="font-weight-medium">
              {{
                values.courseOwner ? values.courseOwner.trainingCenterName : "-"
              }}
            </p>
          </div>
        </div>

        <div class="flex my-4 mb-10">
          <div class="w-1/3 h-8">
            <p class="text-md-left font-weight-bold">Course Accreditor:</p>
          </div>
          <div class="w-1/3 h-8">
            <p class="font-weight-medium">
              {{
                values.courseAccreditor
                    ? values.courseAccreditor.accreditorName
                    : "-"
              }}
            </p>
          </div>


          <div class="w-1/3 h-8">
            <p class="text-md-left font-weight-bold">Accreditation Date:</p>
          </div>

          <div class="w-1/3 h-8">
            <p class="font-weight-medium">
              {{
                values.courseAccreditationDate
                    ? values.courseAccreditationDate
                    : "-"
              }}
            </p>
          </div>
        </div>
        <div class="flex my-4 mb-10">
          <div class="w-1/3 h-8">
            <p class="text-md-left font-weight-bold">
              Passing Score:
            </p>
          </div>
          <div class="w-1/3 h-8">
            <p class="font-weight-medium">
              {{
                values.passingScore
                    ? values.passingScore
                    : "-"
              }}
            </p>
          </div>
        </div>

      </v-card-text>
    </v-card>

    <v-tabs>
      <v-tab>TARGET AUDIENCEs</v-tab>

      <v-tab-item>
        <div v-if="values.courses_target_audiences.length !== 0">
          <v-card v-for="(targetAudience, index) in values.courses_target_audiences" :key="targetAudience.id">
            <v-card-text>
              <div class="flex my-0 mb-0">
                <div class="w-1/3 h-12">
                  <p class="font-weight-medium mb-0">
                    {{
                      targetAudience.health_profession
                          ? targetAudience.health_profession.name
                          : "-"
                    }}<span v-if="index != targetAudience.length - 1">,</span>
                  </p>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </div>
        <div v-else>
          <v-card flat>
            <v-card-title>
              No target audiences to display!
            </v-card-title>
            <v-divider></v-divider>
          </v-card>
        </div>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import VueBarcode from 'vue-barcode';

export default {
  props: {
    course: Object,
  },
  components: {
    'barcode': VueBarcode
  },
  data() {
    return {
      values: [],
    };
  },
  created() {
    if (this.course != null) {
      this.values = this.course;
    }
  },
};
</script>
